
import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { mapState } from 'vuex';
import { showErrorFlash, showFlash } from '~/lib/flash';

@Component({
    components: {
        rating: require('~/components/common/rating/').default,
    }
})
export default class ReviewStatsComponent extends Vue {
    @prop() stats;
    @prop() total;

    get formattedStats() {
        const base = {};
        for (let i = 1; i <= 5; i++) {
            base[i] = '0%';
        }
        this.stats.forEach(element => {
            base[element.rating] = Math.floor(element.count / this.total.review_count * 100) + '%';
        });

        return base;
    }

    get formattedTotalRating() {
        let val = Math.round(this.total.rating * 10).toString();
        return val.substr(0, val.length - 1) + "." + val.substr(val.length - 1)
    }

    get baseString() {
        if ((this.total.review_count > 10 && this.total.review_count < 20) || (this.total.review_count % 10 !== 1)) {
            return 'отзывов';
        }

        return 'отзыва';
    }
}
